module.exports = __webpack_public_path__ + "img/cert-20000-1.00b92339.svg";